import { reactive, ref } from 'vue'
import { useLoader } from '../useLoader'
import { useError } from '../useError'
import { usePoliticalActions } from './usePoliticalActions'
import axios from '@/axios'

const rejectHeaders = reactive([
  { title: '基本情報', attr: 'submissionDate', comment: '' },
  { title: '概要', attr: 'overview', comment: '' },
  { title: '備考', attr: 'remarks', comment: '' },
  { title: '資料', attr: 'files', comment: '' },
])

const isRejectBtnEnabled = ref(false)
const rejectedAttrs = reactive([])

export const useResultReject = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const resetResultRejectedItems = () => {
    while (rejectedAttrs.length > 0) {
      rejectedAttrs.pop()
    }
    rejectHeaders.forEach(x => (x.comment = ''))
  }

  const toUnderscoreCase = str => {
    return str
      .split(/(?=[A-Z])/)
      .join('_')
      .toLowerCase()
  }

  const toSnake = () => {
    for (let i = 0; i < rejectedAttrs.length; i++) {
      Object.keys(rejectedAttrs[i]).forEach(function(key) {
        rejectedAttrs[i][key] = toUnderscoreCase(rejectedAttrs[i][key])
      })
    }
  }
  let data = reactive({})
  const submitReject = async (id, type) => {
    const { getActivitiesAfterResponse } = usePoliticalActions()
    console.log(rejectedAttrs.values)
    try {
      toggleShowLoader(true)
      toSnake()
      data = {
        document_id: id,
        document_type: type,
        sent_back_items: rejectedAttrs,
      }
      let res = null
      res = await axios.post(`/actions/reject`, data)
      await getActivitiesAfterResponse(res)
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return {
    rejectHeaders,
    rejectedAttrs,
    isRejectBtnEnabled,
    resetResultRejectedItems,
    submitReject,
  }
}
